import { render } from "./BackgroundEditor.vue?vue&type=template&id=3515b564&scoped=true"
import script from "./BackgroundEditor.vue?vue&type=script&lang=js"
export * from "./BackgroundEditor.vue?vue&type=script&lang=js"

import "./BackgroundEditor.vue?vue&type=style&index=0&id=3515b564&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\ft\\Coding\\GT Designer\\gtdesigner\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3515b564"]])

export default __exports__